export const DEMO_SETTINGS = {
  version: 'v2.0.0',
  mtime: 1608086512738,
  accounts: {
    'f535254d-4740-5b81-a333-b2440d785991': {
      address: '0xD132973EaEbBd6d7ca7b88e9170f2CCA058de430',
      networkId: 'Ethereum',
      wallet: 'LEDGER_NANO_S_NEW',
      dPath: "m/44'/60'/0'/1",
      assets: [
        {
          uuid: '74cf0f2b-414c-53b7-bd2a-04f78b05aaad',
          name: 'YFI',
          decimal: 18,
          ticker: 'YFI',
          networkId: 'Ethereum',
          contractAddress: '0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e',
          type: 'erc20',
          isCustom: true,
          balance: '202321500806371158',
          mtime: 1608086460261
        },
        {
          ticker: 'LEND',
          name: 'Lend',
          decimal: 18,
          contractAddress: '0x80fB784B7eD66730e8b1DBd9820aFD29931aab03',
          website: 'https://aave.com/',
          support: {
            email: 'support@ethlend.io',
            url: 'https://app.ethlend.io/ticket'
          },
          social: {
            blog: 'https://blog.ethlend.io/',
            facebook: 'https://www.facebook.com/ETHLend/',
            github: 'https://github.com/ETHLend',
            gitter: 'https://gitter.im/EthLend/',
            linkedin: 'https://www.linkedin.com/company/ethlend/',
            reddit: 'https://www.reddit.com/r/ETHLend/',
            telegram: 'https://t.me/ETHLend',
            twitter: 'https://twitter.com/ethlend1',
            youtube: 'https://www.youtube.com/channel/UCZUFYgrvO7xpxzMjijgqWyQ'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'ethlend',
            coinGeckoId: 'ethlend',
            cryptoCompareId: 'LEND',
            cryptoCurrencyIconName: 'lend',
            dexAgId: 'LEND'
          },
          isCustom: false,
          uuid: '1c77b322-a88c-57cc-b956-78c2bc17c360',
          balance: '630691906678978540608',
          mtime: 1608086460261
        },
        {
          ticker: 'AAVE',
          name: 'Aave',
          decimal: 18,
          contractAddress: '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
          website: 'https://aave.com/',
          support: {},
          social: {
            github: 'https://github.com/aave',
            instagram: 'https://www.instagram.com/aave.aave/',
            reddit: 'https://reddit.com/r/Aave_Official',
            telegram: 'https://t.me/Aavesome',
            twitter: 'https://twitter.com/AaveAave'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'aave'
          },
          isCustom: false,
          uuid: '281fa3af-8e6d-5f33-900c-33a480035475',
          balance: '18833844947722839710',
          mtime: 1608086460261
        },
        {
          ticker: 'SNX',
          name: 'Synthetix Network Token',
          decimal: 18,
          contractAddress: '0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F',
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: '2db84be6-32ae-50e3-81b8-59694bef84a1',
          balance: '275587344113190177660',
          mtime: 1608086460261
        },
        {
          ticker: 'PICKLE',
          name: 'Pickle Finance',
          decimal: 18,
          contractAddress: '0x429881672B9AE42b8EbA0E26cD9C73711b891Ca5',
          website: 'https://pickle.finance/',
          support: {},
          social: {
            chat: 'https://discord.com/invite/gR85hmC',
            slack: 'https://discord.com/invite/gR85hmC',
            twitter: 'https://twitter.com/picklefinance'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'pickle-finance'
          },
          isCustom: false,
          uuid: '42362ed0-333d-5123-ae7d-29b79178769d',
          balance: '59243678672295102706',
          mtime: 1608086460261
        },
        {
          ticker: 'SUSHI',
          name: 'SushiToken',
          decimal: 18,
          contractAddress: '0x6B3595068778DD592e39A122f4f5a5cF09C90fE2',
          website: 'https://sushiswapclassic.org/',
          support: {},
          social: {
            blog: 'https://medium.com/@sushiswapchef',
            github: 'https://github.com/sushiswap',
            twitter: 'https://twitter.com/sushiswap'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'sushi'
          },
          isCustom: false,
          uuid: '52f6407e-e3de-50f6-a26a-23702e0efc16',
          balance: '577922269947242821702',
          mtime: 1608086460261
        },
        {
          ticker: 'SNX',
          name: 'Synthetix Network Token',
          decimal: 18,
          contractAddress: '0xC011A72400E58ecD99Ee497CF89E3775d4bd732F',
          website: 'https://synthetix.io',
          support: {
            email: 'info@synthetix.io'
          },
          social: {
            blog: 'https://blog.havven.io',
            chat: 'https://discordapp.com/invite/AEdUHzt',
            github: 'https://github.com/havven/havven',
            linkedin: 'https://www.linkedin.com/company/synthetix/',
            reddit: 'https://www.reddit.com/r/synthetix_io/',
            telegram: 'https://t.me/havven_news',
            twitter: 'https://twitter.com/synthetix_io'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'synthetix-network-token',
            coinGeckoId: 'havven',
            cryptoCompareId: 'SNX',
            dexAgId: 'SNX'
          },
          isCustom: false,
          uuid: 'a24f0eba-c56c-5095-8b45-d4bd5b7063d7',
          balance: '275587344113190177660',
          mtime: 1608086460261
        },
        {
          ticker: 'UNI',
          name: 'Uniswap',
          decimal: 18,
          contractAddress: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
          website: 'https://uniswap.org/',
          support: {},
          social: {
            blog: 'https://uniswap.org/blog/',
            chat: 'https://discord.com/invite/XErMcTq',
            slack: 'https://discord.com/invite/XErMcTq',
            twitter: 'https://twitter.com/UniswapProtocol'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'uniswap'
          },
          isCustom: false,
          uuid: 'c737fec0-a9e9-5841-b4c8-64d48731eb1c',
          balance: '547355298528356574625',
          mtime: 1608086460261
        },
        {
          ticker: 'COMP',
          name: 'Compound',
          decimal: 18,
          contractAddress: '0xc00e94Cb662C3520282E6f5717214004A7f26888',
          website: 'https://compound.finance',
          support: {},
          social: {
            blog: 'https://medium.com/compound-finance',
            chat: 'https://compound.finance/discord',
            github: 'https://github.com/compound-finance',
            reddit: 'https://www.reddit.com/r/Compound/',
            twitter: 'https://twitter.com/compoundfinance'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'compound-governance-token'
          },
          isCustom: false,
          uuid: 'c9a85d0b-5f75-5fd7-9cd2-b94ba5caceef',
          balance: '10179809117252302969',
          mtime: 1608086460261
        },
        {
          ticker: 'MKR',
          name: 'MakerDAO',
          decimal: 18,
          contractAddress: '0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2',
          website: 'https://makerdao.com',
          support: {
            email: 'support@makerdao.com',
            url: 'https://chat.makerdao.com'
          },
          social: {
            chat: 'https://chat.makerdao.com',
            github: 'https://github.com/makerdao',
            reddit: 'https://reddit.com/r/makerdao',
            twitter: 'https://twitter.com/MakerDAO'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'maker',
            coinGeckoId: 'maker',
            cryptoCompareId: 'MKR',
            cryptoCurrencyIconName: 'mkr',
            dexAgId: 'MKR'
          },
          isCustom: false,
          uuid: 'd3230312-cacb-52e6-a849-8bbf6e8142dd',
          balance: '1960339277232014709',
          mtime: 1608086460261
        },
        {
          ticker: 'ETH',
          name: 'Ether (Ethereum)',
          decimal: 18,
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'base',
          mappings: {
            coinCapId: 'ethereum',
            coinGeckoId: 'ethereum',
            cryptoCompareId: 'ETH',
            cryptoCurrencyIconName: 'eth',
            dexAgId: 'ETH'
          },
          isCustom: false,
          uuid: '356a192b-7913-504c-9457-4d18c28d46e6',
          balance: '0',
          mtime: 1608086460261
        }
      ],
      transactions: [],
      favorite: false,
      mtime: 0,
      uuid: 'f535254d-4740-5b81-a333-b2440d785991',
      label: 'Recipient 1'
    },
    '624d4cb6-b9ba-5b46-b40b-02bf4e435b08': {
      address: '0x4bbeEB066eD09B7AEd07bF39EEe0460DFa261520',
      networkId: 'Ethereum',
      wallet: 'VIEW_ONLY',
      assets: [
        {
          ticker: 'BRX',
          name: 'BerryX',
          decimal: 18,
          contractAddress: '0x3A4A0D5b8dfAcd651EE28ed4fFEBf91500345489',
          website: 'https://polar-berry.com',
          support: {
            email: 'info@polar-berry.com'
          },
          social: {
            facebook: 'https://www.facebook.com/polarberrycom',
            github: 'https://github.com/Filinomus/BerryX',
            telegram: 'https://t.me/polarberryx',
            twitter: 'https://twitter.com/Polarberrycom'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: '054937d1-af4a-56cf-b807-5394352e7be8',
          balance: '8000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'LPT',
          name: 'Livepeer Token',
          decimal: 18,
          contractAddress: '0x58b6A8A3302369DAEc383334672404Ee733aB239',
          website: 'https://livepeer.org/',
          support: {
            email: 'contact@livepeer.org',
            url: 'https://forum.livepeer.org'
          },
          social: {
            blog: 'https://medium.com/livepeer-blog',
            chat: 'https://discord.gg/RR4kFAh',
            forum: 'https://forum.livepeer.org',
            github: 'https://github.com/livepeer',
            reddit: 'https://www.reddit.com/r/livepeer/',
            twitter: 'https://twitter.com/LivepeerOrg'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'livepeer',
            coinGeckoId: 'livepeer',
            cryptoCompareId: 'LPT',
            cryptoCurrencyIconName: 'lpt',
            dexAgId: 'LPT'
          },
          isCustom: false,
          uuid: '0765f5fa-f31e-5aa9-9122-c20b90d686f3',
          balance: '2097617225780203852',
          mtime: 1608086460264
        },
        {
          ticker: 'WOLK',
          name: 'WOLK',
          decimal: 18,
          contractAddress: '0x728781E75735dc0962Df3a51d7Ef47E798A7107E',
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: '08a4164c-0989-5f1f-9315-1f4abe9b6bd5',
          balance: '7000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'USDC',
          name: 'USD//Coin',
          decimal: 6,
          contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
          website: 'https://www.centre.io',
          support: {
            url: 'https://www.centre.io'
          },
          social: {
            github: 'https://github.com/centrehq/centre-tokens'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'usd-coin',
            coinGeckoId: 'usd-coin',
            cryptoCompareId: 'USDC',
            cryptoCurrencyIconName: 'usdc',
            dexAgId: 'USDC'
          },
          isCustom: false,
          uuid: '2ed3ebcd-2d4f-52f7-b12b-54360ed49b55',
          balance: '74',
          mtime: 1608086460264
        },
        {
          ticker: 'ODE',
          name: 'ODEM Token',
          decimal: 18,
          contractAddress: '0xbf52F2ab39e26E0951d2a02b49B7702aBe30406a',
          website: 'https://odem.io/',
          support: {
            email: 'support@odem.io'
          },
          social: {
            blog: 'https://medium.com/odem',
            facebook: 'https://www.facebook.com/odemio/',
            github: 'https://github.com/odemio',
            linkedin: 'https://www.linkedin.com/company/odem-io/',
            reddit: 'https://www.reddit.com/r/ODEM/',
            telegram: 'https://t.me/odem_io',
            twitter: 'https://twitter.com/ODEM_IO'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'odem',
            coinGeckoId: 'odem',
            cryptoCompareId: 'ODE'
          },
          isCustom: false,
          uuid: '34d158c5-eed0-51ad-8252-5336a391958a',
          balance: '30000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'REPv2',
          name: 'Reputation',
          decimal: 18,
          contractAddress: '0x221657776846890989a759BA2973e427DfF5C9bB',
          website: 'https://augur.net',
          support: {},
          social: {
            reddit: 'https://www.reddit.com/r/Augur',
            slack: 'https://invite.augur.net',
            twitter: 'https://twitter.com/AugurProject'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'augur',
            cryptoCurrencyIconName: 'rep'
          },
          isCustom: false,
          uuid: '3dcbc269-fa47-5707-b180-4cb0ba6e5cdf',
          balance: '3000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'OMG',
          name: 'OmiseGO',
          decimal: 18,
          contractAddress: '0xd26114cd6EE289AccF82350c8d8487fedB8A0C07',
          website: 'https://omg.omise.co',
          support: {},
          social: {
            github: 'https://github.com/omisego',
            reddit: 'https://reddit.com/r/omise_go',
            twitter: 'https://twitter.com/omise_go'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'omisego',
            coinGeckoId: 'omisego',
            cryptoCompareId: 'OMG',
            cryptoCurrencyIconName: 'omg',
            dexAgId: 'OMG'
          },
          isCustom: false,
          uuid: '3ebda70e-d4a9-5a20-81a1-32f1109d3121',
          balance: '190075404729281652',
          mtime: 1608086460264
        },
        {
          ticker: 'TTV',
          name: 'TV-TWO: Token for Television',
          decimal: 18,
          contractAddress: '0xa838be6E4b760E6061D4732D6B9F11Bf578f9A76',
          website: 'https://tv-two.com',
          support: {
            email: 'team@tv-two.com'
          },
          social: {
            blog: 'https://medium.com/tvtwocom',
            facebook: 'https://www.facebook.com/tvtwocom',
            github: 'https://github.com/tvtwocom',
            instagram: 'https://www.instagram.com/tvtwosecret',
            linkedin: 'https://www.linkedin.com/company/tvtwocom',
            reddit: 'https://www.reddit.com/r/tvtwocom',
            telegram: 'https://t.me/tvtwocom',
            twitter: 'https://twitter.com/tvtwocom',
            youtube: 'https://www.youtube.com/tvtwocom'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'TTV'
          },
          isCustom: false,
          uuid: '4ce50068-0edc-5243-a053-4efbbea6a406',
          balance: '3780000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'AMB',
          name: 'Amber Token',
          decimal: 18,
          contractAddress: '0x4DC3643DbC642b72C158E7F3d2ff232df61cb6CE',
          website: 'https://ambrosus.com/index.html',
          support: {},
          social: {
            blog: 'https://blog.ambrosus.com/',
            facebook: 'https://www.facebook.com/ambrosusAMB',
            github: 'https://github.com/ambrosus',
            linkedin: 'https://www.linkedin.com/company/ambrosus',
            reddit: 'https://www.reddit.com/r/ambrosus/',
            telegram: 'https://t.me/AmbrosusAMB',
            twitter: 'https://twitter.com/AmbrosusAMB',
            youtube: 'https://youtu.be/OkdCV6zw3lI'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'AMB',
            cryptoCurrencyIconName: 'amb'
          },
          isCustom: false,
          uuid: '4e7e2121-1f46-528b-bfe2-1fb1e2b512fb',
          balance: '100010000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'SAI',
          name: 'Dai Stablecoin v1.0',
          decimal: 18,
          contractAddress: '0x89d24A6b4CcB1B6fAA2625fE562bDD9a23260359',
          website: 'https://makerdao.com',
          support: {
            email: 'support@makerdao.com',
            url: 'https://chat.makerdao.com'
          },
          social: {
            chat: 'https://chat.makerdao.com',
            github: 'https://github.com/makerdao',
            reddit: 'https://www.reddit.com/r/MakerDAO',
            twitter: 'https://twitter.com/MakerDAO'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'dai',
            coinGeckoId: 'sai',
            cryptoCompareId: 'SAI',
            cryptoCurrencyIconName: 'dai',
            dexAgId: 'SAI'
          },
          isCustom: false,
          uuid: '53306efd-fb16-5e9a-b6d0-fc0e9713da40',
          balance: '1010170000000000036',
          mtime: 1608086460264
        },
        {
          ticker: 'NOBS',
          name: 'No BS Crypto',
          decimal: 18,
          contractAddress: '0xF4FaEa455575354d2699BC209B0a65CA99F69982',
          website: 'https://nobscrypto.com',
          support: {},
          social: {
            twitter: 'https://twitter.com/noBScrypto'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'no-bs-crypto',
            coinGeckoId: 'no-bs-crypto',
            cryptoCompareId: 'NOBS'
          },
          isCustom: false,
          uuid: '543a4909-8501-575f-b3a5-f3f7117dcc8b',
          balance: '9750000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'KEE',
          name: 'CryptoKEE',
          contractAddress: '0x72D32ac1c5E66BfC5b08806271f8eEF915545164',
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: '54bf63e5-7a23-59ee-805d-de9cc9425ae9',
          balance: '1',
          mtime: 1608086460264
        },
        {
          ticker: 'GNT',
          name: 'Golem',
          decimal: 18,
          contractAddress: '0xa74476443119A942dE498590Fe1f2454d7D4aC0d',
          website: 'https://golem.network',
          support: {
            email: 'contact@golemproject.net'
          },
          social: {
            blog: 'https://blog.golemproject.net/',
            facebook: 'https://www.facebook.com/golemproject/',
            github: 'https://github.com/golemfactory/golem',
            reddit: 'https://reddit.com/r/GolemProject',
            slack: 'https://golemproject.org:3000',
            twitter: 'https://twitter.com/golemproject'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'golem-network-tokens',
            coinGeckoId: 'golem',
            cryptoCompareId: 'GNT',
            cryptoCurrencyIconName: 'gnt',
            dexAgId: 'GNT'
          },
          isCustom: false,
          uuid: '59a6f871-34bb-5914-86cc-b5f1307bb3b9',
          balance: '11000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'BOX',
          name: 'BOX Token',
          decimal: 18,
          contractAddress: '0xe1A178B681BD05964d3e3Ed33AE731577d9d96dD',
          website: 'https://box.la',
          support: {
            email: 'contact@box.la'
          },
          social: {
            blog: 'https://medium.com/@boxla888',
            facebook: 'https://www.facebook.com/boxla888',
            github: 'https://github.com/boxproject',
            reddit: 'https://reddit.com/r/boxla888',
            slack: 'https://box-la.slack.com/',
            telegram: 'https://t.me/safeboxla',
            twitter: 'https://twitter.com/boxla888'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'BOXT'
          },
          isCustom: false,
          uuid: '615801c2-d042-5d4e-b7e1-4dea9d3982a7',
          balance: '5000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'TUSD',
          name: 'TrueUSD',
          decimal: 18,
          contractAddress: '0x0000000000085d4780B73119b644AE5ecd22b376',
          website: 'https://www.trusttoken.com',
          support: {
            email: 'hello@trusttoken.com'
          },
          social: {
            blog: 'https://blog.trusttoken.com',
            github: 'https://github.com/trusttoken',
            reddit: 'https://www.reddit.com/r/TrustToken/',
            telegram: 'https://t.me/joinchat/HihkMkTja1gIyBRM1J1_vg',
            twitter: 'https://twitter.com/TrustToken'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'trueusd',
            coinGeckoId: 'true-usd',
            cryptoCompareId: 'TUSD',
            cryptoCurrencyIconName: 'tusd',
            dexAgId: 'TUSD'
          },
          isCustom: false,
          uuid: '685f1c7f-2d31-56c2-ae80-9cd433aeb0e1',
          balance: '791000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'NGC',
          name: 'NAGA Coin',
          decimal: 18,
          contractAddress: '0x72dD4b6bd852A3AA172Be4d6C5a6dbEc588cf131',
          website: 'https://www.nagaico.com',
          support: {
            email: 'support@nagaico.com'
          },
          social: {
            facebook: 'https://www.facebook.com/thenagaico/',
            twitter: 'https://twitter.com/thenagaico'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'naga',
            coinGeckoId: 'naga',
            cryptoCompareId: 'NGC',
            cryptoCurrencyIconName: 'ngc'
          },
          isCustom: false,
          uuid: '7c39f1de-8bc8-5d03-bee5-6451741664bd',
          balance: '34882546230000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'BRAT',
          name: 'BROTHER',
          decimal: 8,
          contractAddress: '0x9E77D5a1251b6F7D456722A6eaC6D2d5980bd891',
          website: 'http://bro-consortium.io',
          support: {
            email: 'info@brat.red',
            url: 'https://brat.red'
          },
          social: {
            forum: 'https://bitcointalk.org/index.php?topic=2024699.0',
            telegram: 'https://t.me/coinbrat',
            twitter: 'https://twitter.com/coinBrat'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'brat',
            coinGeckoId: 'brother',
            cryptoCompareId: 'BRAT'
          },
          isCustom: false,
          uuid: '7dc10f7d-a63a-516f-a6a1-da2320f1a845',
          balance: '161803398',
          mtime: 1608086460264
        },
        {
          ticker: 'WETH',
          name: 'WETH',
          decimal: 18,
          contractAddress: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
          website: 'https://weth.io',
          support: {
            email: 'support@makerdao.com',
            url: 'https://chat.makerdao.com'
          },
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'weth',
            cryptoCompareId: 'WETH'
          },
          isCustom: false,
          uuid: '7e6f798a-2e6a-5b4c-b7e4-ef6a12cc4d5a',
          balance: '29684406341',
          mtime: 1608086460264
        },
        {
          ticker: 'GCU',
          name: 'Global Currency Unit',
          decimal: 18,
          contractAddress: '0xa4ec83c8907888d006A37debF755ee39766f38ae',
          website: 'http://glpt.io/',
          support: {
            email: 'gcu@glpt.io'
          },
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: '8462cdfd-2c20-5395-8f0d-1e9cd09a409f',
          balance: '5000000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'FGP',
          name: 'FingerPrint',
          decimal: 18,
          contractAddress: '0xd9A8cfe21C232D485065cb62a96866799d4645f7',
          website: 'https://fingerprintcoin.org/',
          support: {
            email: 'info@fingerprintcoin.org'
          },
          social: {
            facebook: 'https://www.facebook.com/fingerprintcoin/',
            forum: 'https://bitcointalk.org/index.php?topic=4776650',
            github: 'https://github.com/FGPTEAM/FingerPrint',
            telegram: 'https://t.me/FingerPrintCoin',
            twitter: 'https://twitter.com/fingerprintcoin'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'fingerprint'
          },
          isCustom: false,
          uuid: '8c5ef44a-ffef-5478-929d-488b0135192f',
          balance: '20000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'DEEZ',
          name: 'DeezNuts',
          decimal: 18,
          contractAddress: '0x075c60EE2cD308ff47873b38Bd9A0Fa5853382c4',
          website: 'https://deeznuts.in',
          support: {
            email: 'deez@deeznuts.in'
          },
          social: {
            blog: 'https://peepeth.com/deeznutstoken',
            facebook: 'https://facebook.com/deeznutstoken',
            github: 'https://github.com/DeezNutsToken/DEEZ',
            instagram: 'https://www.instagram.com/deeznutstoken/',
            telegram: 'http://t.me/deeznutstoken',
            twitter: 'https://twitter.com/DeezNutsToken'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCurrencyIconName: 'deez'
          },
          isCustom: false,
          uuid: '922f002a-707e-54e3-8277-94f0c1504e81',
          balance: '1000000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'BLO',
          name: 'BLONDCOIN',
          decimal: 18,
          contractAddress: '0x1C3BB10dE15C31D5DBE48fbB7B87735d1B7d8c32',
          website: 'http://blondcoin.com',
          support: {
            email: 'support@blondcoin.com',
            url: 'http://blondcoin.com'
          },
          social: {
            github: 'https://github.com/blondcoin',
            linkedin: 'https://www.linkedin.com/in/blondcoin',
            telegram: 'https://t.me/blondcoin',
            twitter: 'https://twitter.com/blondcoin'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: '9a986991-f7df-5bbb-a9a3-360977b57ab5',
          balance: '10000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'SPHTX',
          name: 'SPHTX',
          decimal: 18,
          contractAddress: '0x3833ddA0AEB6947b98cE454d89366cBA8Cc55528',
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'SPHTX'
          },
          isCustom: false,
          uuid: 'a15526dc-57d5-50c7-8ba9-043f4b9dcfc7',
          balance: '3065000000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'DATA',
          name: 'Streamr DATAcoin',
          decimal: 18,
          contractAddress: '0x0Cf0Ee63788A0849fE5297F3407f701E122cC023',
          website: 'https://www.streamr.com',
          support: {
            email: 'contact@streamr.com'
          },
          social: {
            blog: 'https://blog.streamr.com',
            github: 'https://github.com/streamr-dev',
            reddit: 'https://www.reddit.com/r/streamr',
            slack: 'https://slack.streamr.com',
            twitter: 'https://twitter.com/streamr'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'streamr-datacoin',
            coinGeckoId: 'streamr-datacoin',
            cryptoCompareId: 'DATA',
            cryptoCurrencyIconName: 'data',
            dexAgId: 'DATA'
          },
          isCustom: false,
          uuid: 'b4ebfad5-090f-534e-aa26-e77035adc0fc',
          balance: '3822882009289271563',
          mtime: 1608086460264
        },
        {
          ticker: 'JOT',
          name: 'Jury.Online Token',
          decimal: 18,
          contractAddress: '0xdb455c71C1bC2de4e80cA451184041Ef32054001',
          website: 'https://jury.online',
          support: {},
          social: {
            blog: 'https://medium.com/@Jury.Online',
            twitter: 'https://twitter.com/jury2beonline'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'jury-online-token',
            coinGeckoId: 'jury-online-token'
          },
          isCustom: false,
          uuid: 'b79cdc9b-9a97-5413-9a0b-bee09c086c78',
          balance: '500000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'TUSD (OLD)',
          name: 'TrueUSD',
          decimal: 18,
          contractAddress: '0x8dd5fbCe2F6a956C3022bA3663759011Dd51e73E',
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: 'be9dee32-93f5-5c86-9e89-eb0d497535cc',
          balance: '791000000000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'BNFT',
          name: 'Benefits Coin',
          decimal: 9,
          contractAddress: '0xdA2C424Fc98c741c2d4ef2f42897CEfed897CA75',
          support: {
            email: 'support@bnft.life',
            url: 'http://bnft.life'
          },
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'blockchain-benefits'
          },
          isCustom: false,
          uuid: 'c697f7c1-5f8a-5de8-ae44-22687bba713a',
          balance: '31415000000000',
          mtime: 1608086460264
        },
        {
          ticker: 'VIN',
          name: 'VIN',
          decimal: 18,
          contractAddress: '0xF3e014fE81267870624132ef3A646B8E83853a96',
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'VIN'
          },
          isCustom: false,
          uuid: 'c701b7d6-7506-5431-981a-333c47099b86',
          balance: '7770000000000000000',
          mtime: 1608086460265
        },
        {
          ticker: 'UNI',
          name: 'Uniswap',
          decimal: 18,
          contractAddress: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
          website: 'https://uniswap.org/',
          support: {},
          social: {
            blog: 'https://uniswap.org/blog/',
            chat: 'https://discord.com/invite/XErMcTq',
            slack: 'https://discord.com/invite/XErMcTq',
            twitter: 'https://twitter.com/UniswapProtocol'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'uniswap'
          },
          isCustom: false,
          uuid: 'c737fec0-a9e9-5841-b4c8-64d48731eb1c',
          balance: '400135980000000000000',
          mtime: 1608086460265
        },
        {
          ticker: 'XNN',
          name: 'XENON',
          decimal: 18,
          contractAddress: '0xab95E915c123fdEd5BDfB6325e35ef5515F1EA69',
          website: 'https://xenon.network',
          support: {
            email: 'contact@xenon.network'
          },
          social: {
            slack:
              'https://join.slack.com/t/xenonnetwork/shared_invite/enQtMjQ1NzQ2MTQ1OTA2LWI5MjkzZWQxNzRmYzNmOGE5Nzc2MWYyN2NjM2Y2MTZjNjA2MDUyNmI5ZGFkNjU3YzE5NGVjNjA0YzkzMDk5ZGU',
            twitter: 'https://twitter.com/XenonNet'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'XNN'
          },
          isCustom: false,
          uuid: 'c7da0cdc-82b7-51af-9bed-abe9559b6fea',
          balance: '1553680214245400778780',
          mtime: 1608086460265
        },
        {
          ticker: 'PAX',
          name: 'Paxos Standard (PAX)',
          decimal: 18,
          contractAddress: '0x8E870D67F660D95d5be530380D0eC0bd388289E1',
          website: 'https://www.paxos.com/standard',
          support: {
            email: 'help@paxos.com',
            url: 'https://www.paxos.com/contact/'
          },
          social: {
            blog: 'https://www.paxos.com/news-blogs/engineering/',
            github: 'https://github.com/paxosglobal',
            linkedin: 'https://www.linkedin.com/company/paxos',
            twitter: 'https://twitter.com/paxosglobal'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'paxos-standard-token',
            coinGeckoId: 'paxos-standard',
            cryptoCompareId: 'PAX',
            cryptoCurrencyIconName: 'pax',
            dexAgId: 'PAX'
          },
          isCustom: false,
          uuid: 'c90311b2-90b2-5bf4-8d93-e06bd7cfb666',
          balance: '10000000000000000000',
          mtime: 1608086460265
        },
        {
          ticker: 'OAK',
          name: 'OAK',
          decimal: 18,
          contractAddress: '0x5e888B83B7287EED4fB7DA7b7d0A0D4c735d94b3',
          website: 'https://aco.ai',
          support: {
            email: 'support:aco.ai',
            url: 'https://knowledgebase.aco.ai'
          },
          social: {
            blog: 'https://medium.com/theacorncollective',
            facebook: 'https://www.facebook.com/TheAcornCollectiveICO',
            linkedin: 'https://www.linkedin.com/company/acorncollective/',
            reddit: 'https://www.reddit.com/r/TheAcornCollective/',
            telegram: 'https://t.me/joinchat/HI_eCBG0fCRCl1ja-d5JDg',
            twitter: 'https://twitter.com/AcoCollective',
            youtube: 'https://www.youtube.com/channel/UCfwHzwNR66HYtgruKKKxEvA'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'OAK'
          },
          isCustom: false,
          uuid: 'c9e2527d-128e-59d5-8e4a-b5cb427652b3',
          balance: '446000000000000000000',
          mtime: 1608086460265
        },
        {
          ticker: 'TRX',
          name: 'Tron Lab Token',
          decimal: 6,
          contractAddress: '0xf230b790E05390FC8295F4d3F60332c93BEd42e2',
          website: 'https://tronlab.com/en.html',
          support: {
            email: 'service@tronlab.com'
          },
          social: {
            facebook: 'https://www.facebook.com/TronFoundation-144555002795817',
            slack: 'https://tronfoundation.slack.com',
            telegram: 'https://t.me/joinchat/GIjGvkK7dhnO8gapCPfqew',
            twitter: 'https://twitter.com/tronfoundation'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: 'cf928db0-46bd-52c7-8056-c7a08cd5a1d9',
          balance: '151000000',
          mtime: 1608086460265
        },
        {
          ticker: 'BTO',
          name: 'Bottos',
          decimal: 18,
          contractAddress: '0x36905Fc93280f52362A1CBAB151F25DC46742Fb5',
          website: 'https://www.bottos.org',
          support: {},
          social: {
            blog: 'https://medium.com/bottos',
            twitter: 'https://twitter.com/bottos_ai'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'bottos',
            coinGeckoId: 'bottos',
            cryptoCompareId: 'BTO'
          },
          isCustom: false,
          uuid: 'd3e4675a-4ca4-5e05-a4d7-445edcd76965',
          balance: '3872200000000000000000',
          mtime: 1608086460265
        },
        {
          ticker: 'MUXE',
          name: 'MUXE',
          decimal: 18,
          contractAddress: '0x515669d308f887Fd83a471C7764F5d084886D34D',
          website: 'https://www.muxe.io',
          support: {
            email: 'info@muxe.io',
            url: 'https://support.muxe.io'
          },
          social: {
            blog: 'https://www.muxe.io/blog',
            chat: 'https://www.muxe.io',
            facebook: 'https://www.facebook.com/MUXEproject',
            linkedin: 'https://nl.linkedin.com/in/muxe-project',
            reddit: 'https://www.reddit.com/user/MuxeProject',
            telegram: 'https://t.me/MUXEproject',
            twitter: 'https://twitter.com/muxeproject',
            youtube: 'https://www.youtube.com/channel/UCH6oO2fazB72bTdvMGK-H7w'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'muxe'
          },
          isCustom: false,
          uuid: 'daaceb9e-7d95-54fb-a924-d4d013adfb4c',
          balance: '872000000000000000000',
          mtime: 1608086460265
        },
        {
          ticker: 'DAI',
          name: 'Dai Stablecoin v2.0',
          decimal: 18,
          contractAddress: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
          website: 'https://makerdao.com',
          support: {
            email: 'support@makerdao.com',
            url: 'https://chat.makerdao.com'
          },
          social: {
            chat: 'https://chat.makerdao.com',
            github: 'https://github.com/makerdao',
            reddit: 'https://www.reddit.com/r/MakerDAO',
            twitter: 'https://twitter.com/MakerDAO'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'dai',
            coinGeckoId: 'dai',
            cryptoCompareId: 'DAI',
            cryptoCurrencyIconName: 'dai',
            dexAgId: 'DAI'
          },
          isCustom: false,
          uuid: 'e1f698bf-cb85-5405-b563-14774af14bf1',
          balance: '4000000000000000000',
          mtime: 1608086460265
        },
        {
          ticker: 'GSE',
          name: 'GSENetwork',
          decimal: 4,
          contractAddress: '0xe530441f4f73bDB6DC2fA5aF7c3fC5fD551Ec838',
          website: 'https://gse.network',
          support: {
            email: 'info@gselab.org'
          },
          social: {
            blog: 'https://medium.com/@gselabofficial',
            facebook: 'https://www.facebook.com/gselabofficial',
            reddit: 'https://reddit.com/r/GSENetwork',
            telegram: 'https://t.me/GSENetworkOfficial',
            twitter: 'https://twitter.com/gselabofficial'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'gsenetwork',
            coinGeckoId: 'gsenetwork',
            cryptoCompareId: 'GSE'
          },
          isCustom: false,
          uuid: 'e6b79bdf-4c78-5719-aa76-e9944ac8a849',
          balance: '1010000',
          mtime: 1608086460265
        },
        {
          ticker: 'HEX',
          name: 'HEX',
          decimal: 8,
          contractAddress: '0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39',
          website: 'https://hex.win',
          support: {
            url: 'https://t.me/HEXcrypto'
          },
          social: {
            chat: 'https://t.me/HEXcrypto',
            facebook: 'https://www.facebook.com/HEXcrypto',
            github: 'https://github.com/bitcoinHEX',
            instagram: 'https://www.instagram.com/HEXcrypto',
            reddit: 'https://www.reddit.com/r/HEXcrypto',
            telegram: 'https://t.me/HEXcrypto',
            twitter: 'https://twitter.com/HEXCrypto',
            youtube: 'https://youtube.com/HexCrypto'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'HEX'
          },
          isCustom: false,
          uuid: 'f0656669-66a1-5475-af6e-aeb454251845',
          balance: '10000000000',
          mtime: 1608086460265
        },
        {
          ticker: 'OCN',
          name: 'Odyssey',
          decimal: 18,
          contractAddress: '0x4092678e4E78230F46A1534C0fbc8fA39780892B',
          website: 'http://www.ocnex.net',
          support: {},
          social: {
            blog: 'https://cryptomaa.com/coin/OCN/',
            reddit: 'https://www.reddit.com/r/OdysseyOCN',
            twitter: 'https://twitter.com/OdysseyOCN'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'odyssey',
            coinGeckoId: 'odyssey',
            cryptoCompareId: 'OCN'
          },
          isCustom: false,
          uuid: 'f0935aad-cb4c-5f72-bc59-79879d718c87',
          balance: '7000000000000000000',
          mtime: 1608086460265
        },
        {
          ticker: 'KICK',
          name: 'KickToken',
          decimal: 8,
          contractAddress: '0xC12D1c73eE7DC3615BA4e37E4ABFdbDDFA38907E',
          website: 'https://www.kickico.com',
          support: {
            email: 'support@kickico.com'
          },
          social: {
            blog: 'https://medium.com/@kickecosystem',
            chat: 'https://t.me/kickico',
            facebook: 'https://www.facebook.com/kickecosystem',
            github: 'https://github.com/kickecosystem/',
            linkedin: 'https://www.linkedin.com/company/kickecosystem/',
            reddit: 'https://www.reddit.com/r/KICKICO_Platform/',
            telegram: 'https://t.me/kickico',
            twitter: 'https://twitter.com/KickEcosystem'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'KICK'
          },
          isCustom: false,
          uuid: 'f383cc01-4942-5d0e-8442-3dbbc8cc8836',
          balance: '88888800000000',
          mtime: 1608086460265
        },
        {
          ticker: 'ETH',
          name: 'Ether (Ethereum)',
          decimal: 18,
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'base',
          mappings: {
            coinCapId: 'ethereum',
            coinGeckoId: 'ethereum',
            cryptoCompareId: 'ETH',
            cryptoCurrencyIconName: 'eth',
            dexAgId: 'ETH'
          },
          isCustom: false,
          uuid: '356a192b-7913-504c-9457-4d18c28d46e6',
          balance: '241467128207651839829',
          mtime: 1608086460265
        }
      ],
      transactions: [],
      favorite: false,
      mtime: 0,
      uuid: '624d4cb6-b9ba-5b46-b40b-02bf4e435b08',
      label: 'MyCrypto Team Tip Jar'
    },
    'f625fa21-20ed-5154-a785-d88fbb85f58a': {
      address: '0x8000F432747ccDc71B9DF9F8eB96EFfeeac6218E',
      networkId: 'Ethereum',
      wallet: 'TREZOR',
      dPath: "m/44'/60'/0'/1",
      assets: [
        {
          ticker: 'SENT',
          name: 'SENTinel',
          decimal: 8,
          contractAddress: '0xa44E5137293E855B1b7bC7E2C6f8cD796fFCB037',
          website: 'https://sentinel.co',
          support: {},
          social: {
            reddit: 'https://www.reddit.com/r/SENT',
            twitter: 'https://twitter.com/Sentinel_co'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'SENT'
          },
          isCustom: false,
          uuid: '1d2241f2-8f7f-50e5-b70f-cc2e33b1c4e9',
          balance: '100013135159412',
          mtime: 1608086460266
        },
        {
          ticker: 'AAVE',
          name: 'Aave',
          decimal: 18,
          contractAddress: '0x7Fc66500c84A76Ad7e9c93437bFc5Ac33E2DDaE9',
          website: 'https://aave.com/',
          support: {},
          social: {
            github: 'https://github.com/aave',
            instagram: 'https://www.instagram.com/aave.aave/',
            reddit: 'https://reddit.com/r/Aave_Official',
            telegram: 'https://t.me/Aavesome',
            twitter: 'https://twitter.com/AaveAave'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'aave'
          },
          isCustom: false,
          uuid: '281fa3af-8e6d-5f33-900c-33a480035475',
          balance: '15227880505181302023',
          mtime: 1608086460266
        },
        {
          ticker: 'SNX',
          name: 'Synthetix Network Token',
          decimal: 18,
          contractAddress: '0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F',
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: '2db84be6-32ae-50e3-81b8-59694bef84a1',
          balance: '2097387572580485482628',
          mtime: 1608086460266
        },
        {
          ticker: 'SALT',
          name: 'Salt Lending Token',
          decimal: 8,
          contractAddress: '0x4156D3342D5c385a87D264F90653733592000581',
          website: 'https://saltlending.com',
          support: {},
          social: {
            slack: 'saltcommunity.slack.com',
            twitter: 'https://twitter.com/SaltLending'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'SALT',
            dexAgId: 'SALT'
          },
          isCustom: false,
          uuid: '2fdbfe5d-5e3a-5fe0-bcaa-42810867d1e6',
          balance: '700000000',
          mtime: 1608086460266
        },
        {
          ticker: 'DEPO (Depository Network)',
          name: 'DEPO (Depository Network)',
          decimal: 18,
          contractAddress: '0x89cbeAC5E8A13F0Ebb4C74fAdFC69bE81A501106',
          website: 'https://depository.network',
          support: {
            email: 'support@depository.network',
            url: 'https://depository.network/'
          },
          social: {
            blog: 'https://depository.network/blog/',
            facebook: 'https://www.facebook.com/depository.network/',
            forum: 'https://bitcointalk.org/index.php?topic=4544199',
            github: 'https://github.com/DepositoryNetwork/DepositoryTokenSmartContract',
            linkedin: 'https://www.linkedin.com/company/depositorynetwork/',
            reddit: 'https://www.reddit.com/r/DepositoryNetworkDepo/',
            telegram: 'https://t.me/depositorynetwork',
            twitter: 'https://twitter.com/deponetwork',
            youtube: 'https://www.youtube.com/channel/UCi7oC83SlkcDXQa5eA0Bkxg'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'DEPO'
          },
          isCustom: false,
          uuid: '3c51b9f8-f813-5455-b4ce-7a9fa9f4975c',
          balance: '1500000000000000000000',
          mtime: 1608086460266
        },
        {
          ticker: 'FKX',
          name: 'Knoxstertoken',
          decimal: 18,
          contractAddress: '0x009e864923b49263c7F10D19B7f8Ab7a9A5AAd33',
          website: 'https://fortknoxster.com',
          support: {
            email: 'hello@fortknoxster.com',
            url: 'https://fortknoxster.com/knowledge-base/'
          },
          social: {
            blog: 'https://medium.com/fortknoxster',
            facebook: 'https://www.facebook.com/FortKnoxster',
            github: 'https://github.com/FortKnoxster',
            reddit: 'https://www.reddit.com/r/FortKnoxster/',
            telegram: 'https://t.me/FortKnoxster',
            twitter: 'https://twitter.com/FortKnoxster',
            youtube: 'https://www.youtube.com/channel/UCZB8URO26cktviSxp3SeHig/videos'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'knoxstertoken',
            coinGeckoId: 'fortknoxter',
            cryptoCompareId: 'FKX'
          },
          isCustom: false,
          uuid: '4ca1289d-7126-5a11-8be3-2fc7f6c45820',
          balance: '50000000000000000000',
          mtime: 1608086460266
        },
        {
          ticker: 'FDZ',
          name: 'Friendz',
          decimal: 18,
          contractAddress: '0x23352036E911A22Cfc692B5E2E196692658ADED9',
          website: 'https://friendz.io',
          support: {},
          social: {
            reddit: 'https://www.reddit.com/r/FriendzICO',
            twitter: 'https://twitter.com/Friendz_ICO'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'friends',
            coinGeckoId: 'friendz',
            cryptoCompareId: 'FDZ'
          },
          isCustom: false,
          uuid: '5d06038d-8c66-5921-958e-4be4421944c5',
          balance: '30000000000000000000',
          mtime: 1608086460266
        },
        {
          ticker: 'PRO',
          name: 'Propy',
          decimal: 8,
          contractAddress: '0x226bb599a12C826476e3A771454697EA52E9E220',
          website: 'https://propy.com',
          support: {
            email: 'ico@propy.com'
          },
          social: {
            blog: 'https://medium.com/@propy',
            facebook: 'https://www.facebook.com/propyinc',
            linkedin: 'https://www.linkedin.com/company/propy-inc-',
            slack: 'https://propy.slack.com',
            telegram: 'https://t.me/propy',
            twitter: 'https://twitter.com/propyinc'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'propy',
            coinGeckoId: 'propy',
            cryptoCompareId: 'PRO'
          },
          isCustom: false,
          uuid: '5e895083-fac7-5033-ae8a-a0f317f230ff',
          balance: '10100000000',
          mtime: 1608086460266
        },
        {
          ticker: 'sUSD',
          name: 'Synth USD',
          decimal: 18,
          contractAddress: '0x289e9a4674663decEE54f781AaDE5327304A32f8',
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            dexAgId: 'SUSD'
          },
          isCustom: false,
          uuid: '6c52f4a7-6b8f-557c-aeb8-d064c5ea2c03',
          balance: '2870508870832964801',
          mtime: 1608086460266
        },
        {
          ticker: 'BNT',
          name: 'Bancor Network Token',
          decimal: 18,
          contractAddress: '0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C',
          website: 'https://www.bancor.network',
          support: {},
          social: {
            blog: 'https://blog.bancor.network/',
            facebook: 'https://www.facebook.com/bancor',
            github: 'https://github.com/bancorprotocol',
            reddit: 'https://www.reddit.com/r/Bancor/',
            telegram: 'https://t.me/bancor',
            twitter: 'https://twitter.com/bancor'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'bancor',
            coinGeckoId: 'bancor',
            cryptoCompareId: 'BNT',
            cryptoCurrencyIconName: 'bnt',
            dexAgId: 'BNT'
          },
          isCustom: false,
          uuid: '778541d2-65e6-5c57-b083-aa3129eb91c8',
          balance: '1049662512170233078',
          mtime: 1608086460266
        },
        {
          ticker: 'WETH',
          name: 'WETH',
          decimal: 18,
          contractAddress: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2',
          website: 'https://weth.io',
          support: {
            email: 'support@makerdao.com',
            url: 'https://chat.makerdao.com'
          },
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'weth',
            cryptoCompareId: 'WETH'
          },
          isCustom: false,
          uuid: '7e6f798a-2e6a-5b4c-b7e4-ef6a12cc4d5a',
          balance: '33061462149542983',
          mtime: 1608086460266
        },
        {
          ticker: 'sUSD',
          name: 'USD Synth (sUSD)',
          decimal: 18,
          contractAddress: '0x57Ab1E02fEE23774580C119740129eAC7081e9D3',
          website: 'https://www.synthetix.io',
          support: {
            email: 'info@synthetix.io'
          },
          social: {
            blog: 'https://blog.havven.io',
            chat: 'https://discordapp.com/invite/AEdUHzt',
            github: 'https://github.com/havven/',
            linkedin: 'https://www.linkedin.com/company/synthetix/',
            reddit: 'https://www.reddit.com/r/synthetix_io/',
            twitter: 'https://twitter.com/synthetix_io'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'SUSD',
            dexAgId: 'SUSD'
          },
          isCustom: false,
          uuid: '933d3751-169e-579c-a310-e649a8382317',
          balance: '2870508870832964801',
          mtime: 1608086460266
        },
        {
          ticker: 'WAB',
          name: 'WABnetwork',
          decimal: 18,
          contractAddress: '0x4BBbC57aF270138Ef2FF2C50DbfAD684e9E0e604',
          website: 'https://wab.network',
          support: {},
          social: {
            blog: 'https://medium.com/@WABnetwork',
            twitter: 'https://twitter.com/WABnetwork'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'wabnetwork',
            coinGeckoId: 'wab-network-2',
            cryptoCompareId: 'WAB'
          },
          isCustom: false,
          uuid: '93686561-3c9d-5bc8-81bf-0334150be221',
          balance: '10000000000000000000000',
          mtime: 1608086460267
        },
        {
          ticker: 'SNX',
          name: 'Synthetix Network Token',
          decimal: 18,
          contractAddress: '0xC011A72400E58ecD99Ee497CF89E3775d4bd732F',
          website: 'https://synthetix.io',
          support: {
            email: 'info@synthetix.io'
          },
          social: {
            blog: 'https://blog.havven.io',
            chat: 'https://discordapp.com/invite/AEdUHzt',
            github: 'https://github.com/havven/havven',
            linkedin: 'https://www.linkedin.com/company/synthetix/',
            reddit: 'https://www.reddit.com/r/synthetix_io/',
            telegram: 'https://t.me/havven_news',
            twitter: 'https://twitter.com/synthetix_io'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'synthetix-network-token',
            coinGeckoId: 'havven',
            cryptoCompareId: 'SNX',
            dexAgId: 'SNX'
          },
          isCustom: false,
          uuid: 'a24f0eba-c56c-5095-8b45-d4bd5b7063d7',
          balance: '2097387572580485482628',
          mtime: 1608086460267
        },
        {
          ticker: 'FACE',
          name: 'Faceter',
          decimal: 18,
          contractAddress: '0x1CCAA0F2a7210d76E1fDec740d5F323E2E1b1672',
          website: 'https://tokensale.faceter.io',
          support: {},
          social: {
            blog: 'https://medium.com/faceter',
            twitter: 'https://twitter.com/FaceterOfficial'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'faceter',
            coinGeckoId: 'face',
            cryptoCompareId: 'FACE'
          },
          isCustom: false,
          uuid: 'a3131ec3-7689-50b3-b135-0d36a676c90b',
          balance: '5600000000000000000000',
          mtime: 1608086460267
        },
        {
          ticker: 'CAN',
          name: 'CanYaCoin',
          decimal: 6,
          contractAddress: '0x1d462414fe14cf489c7A21CaC78509f4bF8CD7c0',
          website: 'https://canya.io',
          support: {
            url: 'support@canya.io'
          },
          social: {
            blog: 'https://medium.com/canyacoin',
            reddit: 'https://www.reddit.com/r/CanYaCoin',
            telegram: 'https://t.me/joinchat/HBzcbUP42NwHZKBwnEIkkw',
            twitter: 'https://twitter.com/canyacoin'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'canyacoin',
            coinGeckoId: 'canyacoin',
            cryptoCompareId: 'CAN'
          },
          isCustom: false,
          uuid: 'b3aed520-c84f-566c-9431-5263a2d40460',
          balance: '2000000',
          mtime: 1608086460267
        },
        {
          ticker: 'UNI',
          name: 'Uniswap',
          decimal: 18,
          contractAddress: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984',
          website: 'https://uniswap.org/',
          support: {},
          social: {
            blog: 'https://uniswap.org/blog/',
            chat: 'https://discord.com/invite/XErMcTq',
            slack: 'https://discord.com/invite/XErMcTq',
            twitter: 'https://twitter.com/UniswapProtocol'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'uniswap'
          },
          isCustom: false,
          uuid: 'c737fec0-a9e9-5841-b4c8-64d48731eb1c',
          balance: '56854405415665726390',
          mtime: 1608086460267
        },
        {
          ticker: 'COMP',
          name: 'Compound',
          decimal: 18,
          contractAddress: '0xc00e94Cb662C3520282E6f5717214004A7f26888',
          website: 'https://compound.finance',
          support: {},
          social: {
            blog: 'https://medium.com/compound-finance',
            chat: 'https://compound.finance/discord',
            github: 'https://github.com/compound-finance',
            reddit: 'https://www.reddit.com/r/Compound/',
            twitter: 'https://twitter.com/compoundfinance'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'compound-governance-token'
          },
          isCustom: false,
          uuid: 'c9a85d0b-5f75-5fd7-9cd2-b94ba5caceef',
          balance: '6601132606841057',
          mtime: 1608086460267
        },
        {
          ticker: 'RBLX',
          name: 'Rublix',
          decimal: 18,
          contractAddress: '0xFc2C4D8f95002C14eD0a7aA65102Cac9e5953b5E',
          website: 'https://rublix.io/',
          support: {
            email: 'info@rublix.io'
          },
          social: {
            blog: 'https://blog.rublix.io/',
            facebook: 'https://www.facebook.com/Rublixdev/',
            github: 'https://github.com/rublixdev',
            instagram: 'https://www.instagram.com/rublixdev/',
            reddit: 'https://www.reddit.com/r/Rublix/',
            telegram: 'https://t.me/rublixdev',
            twitter: 'https://twitter.com/RublixDev'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'rublix',
            coinGeckoId: 'rublix'
          },
          isCustom: false,
          uuid: 'cfd7b234-57bd-5306-89e8-3d477c4cbb83',
          balance: '7500000000000000000',
          mtime: 1608086460267
        },
        {
          ticker: 'sUSD',
          name: 'Synth sUSD',
          decimal: 18,
          contractAddress: '0x57Ab1ec28D129707052df4dF418D58a2D46d5f51',
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: 'd0f5269a-78c6-5734-a6a7-0c9b46107582',
          balance: '2870508870832964801',
          mtime: 1608086460267
        },
        {
          ticker: 'REMI',
          name: 'REMI',
          decimal: 18,
          contractAddress: '0x13cb85823f78Cff38f0B0E90D3e975b8CB3AAd64',
          website: 'https://remiit.io',
          support: {
            email: 'contact@remiit.io'
          },
          social: {
            blog: 'https://medium.com/remiit/',
            facebook: 'https://www.facebook.com/remiit.io/',
            github: 'https://github.com/remiit',
            instagram: 'https://www.instagram.com/remiitplatform/',
            linkedin: 'https://www.linkedin.com/company/wehado/',
            reddit: 'https://www.reddit.com/r/remiit',
            telegram: 'https://t.me/remiit',
            twitter: 'https://twitter.com/remiitplatform',
            youtube: 'https://www.youtube.com/watch?v=_ci4TiNvfkU'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'remiit'
          },
          isCustom: false,
          uuid: 'd339805d-b72c-5546-a10e-2a74f425d9d2',
          balance: '1250000000000000000000',
          mtime: 1608086460267
        },
        {
          ticker: 'BRD',
          name: 'Bread',
          decimal: 18,
          contractAddress: '0x558EC3152e2eb2174905cd19AeA4e34A23DE9aD6',
          website: 'https://token.breadapp.com/en',
          support: {
            email: 'tokensupport@breadapp.com'
          },
          social: {
            blog: 'https://breadapp.com/blog/',
            facebook: 'https://www.facebook.com/breadapp/',
            github: 'https://github.com/breadwallet',
            reddit: 'https://www.reddit.com/r/breadwallet/',
            telegram: 'https://t.me/joinchat/HclhZ0q7-w8kx5NjYTa7Vw',
            twitter: 'https://twitter.com/breadapp'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'bread',
            coinGeckoId: 'bread',
            cryptoCompareId: 'BRD',
            cryptoCurrencyIconName: 'brd'
          },
          isCustom: false,
          uuid: 'd48a25ca-8d2b-596f-a852-79407565b6e4',
          balance: '30000000000000000000',
          mtime: 1608086460267
        },
        {
          ticker: 'BAL',
          name: 'Balancer',
          decimal: 18,
          contractAddress: '0xba100000625a3754423978a60c9317c58a424e3D',
          website: 'https://balancer.finance',
          support: {
            email: 'contact@balancer.finance'
          },
          social: {
            blog: 'https://medium.com/balancer-protocol',
            github: 'https://github.com/balancer-labs',
            twitter: 'https://twitter.com/BalancerLabs'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinGeckoId: 'balancer'
          },
          isCustom: false,
          uuid: 'e02a1b4e-ab8b-5894-a49e-a36b74bd99ab',
          balance: '153551',
          mtime: 1608086460267
        },
        {
          ticker: 'KICK',
          name: 'KickToken',
          decimal: 8,
          contractAddress: '0xC12D1c73eE7DC3615BA4e37E4ABFdbDDFA38907E',
          website: 'https://www.kickico.com',
          support: {
            email: 'support@kickico.com'
          },
          social: {
            blog: 'https://medium.com/@kickecosystem',
            chat: 'https://t.me/kickico',
            facebook: 'https://www.facebook.com/kickecosystem',
            github: 'https://github.com/kickecosystem/',
            linkedin: 'https://www.linkedin.com/company/kickecosystem/',
            reddit: 'https://www.reddit.com/r/KICKICO_Platform/',
            telegram: 'https://t.me/kickico',
            twitter: 'https://twitter.com/KickEcosystem'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'KICK'
          },
          isCustom: false,
          uuid: 'f383cc01-4942-5d0e-8442-3dbbc8cc8836',
          balance: '88888800000000',
          mtime: 1608086460267
        },
        {
          ticker: 'DAN',
          name: 'DaneelToken',
          decimal: 10,
          contractAddress: '0x9B70740e708a083C6fF38Df52297020f5DfAa5EE',
          website: 'https://daneel.io',
          support: {
            email: 'information@daneel.io'
          },
          social: {
            blog: 'https://medium.com/@daneel_project',
            facebook: 'https://fb.me/daneelproject',
            forum: 'https://bitcointalk.org/index.php?topic=2376203',
            github: 'https://github.com/project-daneel',
            telegram: 'https://t.me/DaneelCommunity',
            twitter: 'https://twitter.com/daneelproject'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'daneel',
            coinGeckoId: 'daneel',
            cryptoCompareId: 'DAN'
          },
          isCustom: false,
          uuid: 'f774001a-d201-5445-b63a-6221f63c237b',
          balance: '500000000000',
          mtime: 1608086460267
        },
        {
          ticker: 'ETH',
          name: 'Ether (Ethereum)',
          decimal: 18,
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'base',
          mappings: {
            coinCapId: 'ethereum',
            coinGeckoId: 'ethereum',
            cryptoCompareId: 'ETH',
            cryptoCurrencyIconName: 'eth',
            dexAgId: 'ETH'
          },
          isCustom: false,
          uuid: '356a192b-7913-504c-9457-4d18c28d46e6',
          balance: '964066756341671104',
          mtime: 1608086460267
        }
      ],
      transactions: [],
      favorite: false,
      mtime: 0,
      uuid: 'f625fa21-20ed-5154-a785-d88fbb85f58a',
      label: 'My Account #1'
    },
    '78d42968-6071-5a72-8dd0-9ca4c6c55e83': {
      address: '0xA42830eE059c77cAF8c8200B44AA9813CB0720c5',
      isPrivate: true,
      networkId: 'Ethereum',
      wallet: 'METAMASK',
      assets: [
        {
          uuid: '74cf0f2b-414c-53b7-bd2a-04f78b05aaad',
          name: 'YFI',
          decimal: 18,
          ticker: 'YFI',
          networkId: 'Ethereum',
          contractAddress: '0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e',
          type: 'erc20',
          isCustom: true,
          balance: '3001118871375395653',
          mtime: 1608086460267
        },
        {
          ticker: 'USDT',
          name: 'USD Tether (erc20)',
          decimal: 6,
          contractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
          website: 'https://tether.to',
          support: {
            email: 'billy@tether.to'
          },
          social: {
            twitter: 'https://twitter.com/tether_to'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'tether',
            coinGeckoId: 'tether',
            cryptoCompareId: 'USDT',
            cryptoCurrencyIconName: 'usdt',
            dexAgId: 'USDT'
          },
          isCustom: false,
          uuid: '00ff8c75-22ce-5e15-b06a-770154d7e333',
          balance: '45817321',
          mtime: 1608086460267
        },
        {
          ticker: 'USDC',
          name: 'USD//Coin',
          decimal: 6,
          contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
          website: 'https://www.centre.io',
          support: {
            url: 'https://www.centre.io'
          },
          social: {
            github: 'https://github.com/centrehq/centre-tokens'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'usd-coin',
            coinGeckoId: 'usd-coin',
            cryptoCompareId: 'USDC',
            cryptoCurrencyIconName: 'usdc',
            dexAgId: 'USDC'
          },
          isCustom: false,
          uuid: '2ed3ebcd-2d4f-52f7-b12b-54360ed49b55',
          balance: '10000805585',
          mtime: 1608086460267
        },
        {
          ticker: 'OCEAN',
          name: 'Ocean Token',
          decimal: 18,
          contractAddress: '0x967da4048cD07aB37855c090aAF366e4ce1b9F48',
          website: 'https://oceanprotocol.com',
          support: {},
          social: {
            blog: 'https://blog.oceanprotocol.com',
            chat: 'https://discord.gg/TnXjkR5',
            forum: 'https://port.oceanprotocol.com',
            github: 'https://github.com/oceanprotocol',
            linkedin: 'https://www.linkedin.com/company/ocean-protocol',
            telegram: 'https://t.me/OceanProtocol_Community',
            twitter: 'https://twitter.com/oceanprotocol'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: '37055a94-c2bc-5f79-80c4-faaa93d1ff87',
          balance: '50000778390000000000000',
          mtime: 1608086460267
        },
        {
          ticker: 'DIP',
          name: 'Decentralized Insurance Protocol',
          decimal: 18,
          contractAddress: '0xc719d010B63E5bbF2C0551872CD5316ED26AcD83',
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'DIP',
            dexAgId: 'DIP'
          },
          isCustom: false,
          uuid: '66e28eb6-b405-5440-a277-bd4450f94537',
          balance: '304566662517509708117235',
          mtime: 1608086460267
        },
        {
          ticker: 'OCTO',
          name: 'OctoFi',
          decimal: 18,
          contractAddress: '0x7240aC91f01233BaAf8b064248E80feaA5912BA3',
          website: 'https://octo.fi',
          support: {
            email: 'hello@octo.fi'
          },
          social: {
            blog: 'https://octo.fi/blog/',
            github: 'https://github.com/octofi',
            linkedin: 'https://www.linkedin.com/company/octofinance/',
            telegram: 'https://t.me/OctoFiNews',
            twitter: 'https://twitter.com/octofinance'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {},
          isCustom: false,
          uuid: '9e34106e-2062-535e-8111-3320b2008f58',
          balance: '815283375256471524590',
          mtime: 1608086460267
        },
        {
          ticker: 'PAXG',
          name: 'Paxos Gold',
          decimal: 18,
          contractAddress: '0x45804880De22913dAFE09f4980848ECE6EcbAf78',
          website: 'https://www.paxos.com/paxgold',
          support: {
            email: 'paxgold@paxos.com'
          },
          social: {
            blog: 'https://medium.com/Paxos',
            facebook: 'http://facebook.com/paxosglobal',
            github: 'https://github.com/paxosglobal/paxos-gold-contract',
            linkedin: 'https://www.linkedin.com/company/paxos/',
            twitter: 'https://twitter.com/PaxosGlobal'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            cryptoCompareId: 'PAXG'
          },
          isCustom: false,
          uuid: 'b7b4cc77-fb11-56d7-86e1-cd21165b4370',
          balance: '2689855921200000000',
          mtime: 1608086460267
        },
        {
          ticker: 'LINK (Chainlink)',
          name: 'LINK Chainlink',
          decimal: 18,
          contractAddress: '0x514910771AF9Ca656af840dff83E8264EcF986CA',
          website: 'https://link.smartcontract.com',
          support: {
            email: 'support@smartcontract.com'
          },
          social: {
            slack: 'https://chainlinknetwork.slack.com'
          },
          networkId: 'Ethereum',
          type: 'erc20',
          mappings: {
            coinCapId: 'chainlink',
            coinGeckoId: 'chainlink',
            cryptoCompareId: 'LINK'
          },
          isCustom: false,
          uuid: 'c0ae47d5-f020-5ea8-9886-522d3af70845',
          balance: '3000409043060201543890',
          mtime: 1608086460267
        },
        {
          ticker: 'ETH',
          name: 'Ether (Ethereum)',
          decimal: 18,
          support: {},
          social: {},
          networkId: 'Ethereum',
          type: 'base',
          mappings: {
            coinCapId: 'ethereum',
            coinGeckoId: 'ethereum',
            cryptoCompareId: 'ETH',
            cryptoCurrencyIconName: 'eth',
            dexAgId: 'ETH'
          },
          isCustom: false,
          uuid: '356a192b-7913-504c-9457-4d18c28d46e6',
          balance: '1594010623581686155',
          mtime: 1608086460267
        }
      ],
      transactions: [],
      favorite: false,
      mtime: 0,
      uuid: '78d42968-6071-5a72-8dd0-9ca4c6c55e83',
      label: 'Recipient 3'
    }
  },
  addressBook: {
    'a1acf1f2-0380-5bd6-90c3-2b4a0974a6fe': {
      label: 'MyCrypto Team Tip Jar',
      address: '0x4bbeEB066eD09B7AEd07bF39EEe0460DFa261520',
      notes: "This is MyCrypto's Donate address. Feel free to delete it!",
      network: 'Ethereum',
      uuid: 'a1acf1f2-0380-5bd6-90c3-2b4a0974a6fe'
    },
    'f535254d-4740-5b81-a333-b2440d785991': {
      address: '0xd132973eaebbd6d7ca7b88e9170f2cca058de430',
      label: 'My Account #2',
      notes: '',
      network: 'Ethereum',
      uuid: 'f535254d-4740-5b81-a333-b2440d785991'
    },
    'f625fa21-20ed-5154-a785-d88fbb85f58a': {
      address: '0x8000f432747ccdc71b9df9f8eb96effeeac6218e',
      label: 'My Account #1',
      notes: '',
      network: 'Ethereum',
      uuid: 'f625fa21-20ed-5154-a785-d88fbb85f58a'
    },
    '78d42968-6071-5a72-8dd0-9ca4c6c55e83': {
      address: '0xa42830ee059c77caf8c8200b44aa9813cb0720c5',
      label: 'My Account #3',
      notes: '',
      network: 'Ethereum',
      uuid: '78d42968-6071-5a72-8dd0-9ca4c6c55e83'
    }
  },
  assets: {
    '74cf0f2b-414c-53b7-bd2a-04f78b05aaad': {
      uuid: '74cf0f2b-414c-53b7-bd2a-04f78b05aaad',
      name: 'YFI',
      decimal: 18,
      ticker: 'YFI',
      networkId: 'Ethereum',
      contractAddress: '0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e',
      type: 'erc20',
      isCustom: true
    },
    'df0cc14b-ce6a-544f-83ea-e78f21b31cae': {
      uuid: 'df0cc14b-ce6a-544f-83ea-e78f21b31cae',
      name: 'BASED',
      decimal: 18,
      ticker: 'BASED',
      networkId: 'Ethereum',
      contractAddress: '0x68A118Ef45063051Eac49c7e647CE5Ace48a68a5',
      type: 'erc20',
      isCustom: true
    },
    '5e0b14d9-c63b-5550-beaf-1e09ce3f2c0d': {
      uuid: '5e0b14d9-c63b-5550-beaf-1e09ce3f2c0d',
      name: 'WOM',
      decimal: 18,
      ticker: 'WOM',
      networkId: 'Ethereum',
      contractAddress: '0xBd356a39BFf2cAda8E9248532DD879147221Cf76',
      type: 'erc20',
      isCustom: true
    }
  },
  contracts: {},
  networks: {},
  notifications: {
    '98deb58d-f747-4570-9deb-9599ec503425': {
      uuid: '98deb58d-f747-4570-9deb-9599ec503425',
      template: 'save-settings',
      dateDisplayed: '2020-11-21T07:01:36.606Z',
      dismissed: false,
      viewed: true
    },
    '86540e5f-9f20-4662-ab3e-9eb8c52e984d': {
      uuid: '86540e5f-9f20-4662-ab3e-9eb8c52e984d',
      template: 'wallet-added',
      templateData: {
        address: '0xJordAnSPence.Eth'
      },
      dateDisplayed: '2020-11-21T07:01:36.606Z',
      dismissed: true,
      dateDismissed: '2020-12-16T02:36:49.188Z'
    },
    '2ade234f-0e44-4cf4-b055-8edcc8300c10': {
      uuid: '2ade234f-0e44-4cf4-b055-8edcc8300c10',
      template: 'onboarding-responsible',
      templateData: {
        firstDashboardVisitDate: '2020-11-04T03:54:50.842Z'
      },
      dateDisplayed: '2020-12-07T21:12:26.524Z',
      dismissed: true,
      viewed: true,
      dateDismissed: '2020-12-07T21:12:29.615Z'
    },
    'a4b524df-3428-4376-8ee0-3160528fe71b': {
      uuid: 'a4b524df-3428-4376-8ee0-3160528fe71b',
      template: 'onboarding-please-understand',
      templateData: {
        previousNotificationClosedDate: '2020-12-07T21:12:29.615Z'
      },
      dateDisplayed: '2020-12-16T02:40:44.267Z',
      dismissed: false,
      viewed: true
    }
  },
  rates: {
    '356a192b-7913-504c-9457-4d18c28d46e6': {
      usd: 585.88,
      eur: 482.06,
      gbp: 435.77,
      rub: 42977,
      inr: 43085,
      cny: 3833.83,
      try: 4595.13
    },
    'e1f698bf-cb85-5405-b563-14774af14bf1': {
      usd: 1,
      eur: 0.825804,
      gbp: 0.746441,
      rub: 73.62,
      inr: 73.82,
      cny: 6.57,
      try: 7.87
    },
    '2ed3ebcd-2d4f-52f7-b12b-54360ed49b55': {
      usd: 1,
      eur: 0.822804,
      gbp: 0.743787,
      rub: 73.35,
      inr: 73.54,
      cny: 6.54,
      try: 7.84
    },
    'c737fec0-a9e9-5841-b4c8-64d48731eb1c': {
      usd: 3.3,
      eur: 2.72,
      gbp: 2.46,
      rub: 242.29,
      inr: 242.9,
      cny: 21.61,
      try: 25.91
    },
    '7f4d2f19-9a76-5930-b63b-ac9b0afe6201': {
      usd: 2.81,
      eur: 2.41,
      gbp: 2.16,
      rub: 221.49,
      inr: 209.52,
      cny: 18.82,
      try: 23.63
    },
    '7e6f798a-2e6a-5b4c-b7e4-ef6a12cc4d5a': {
      usd: 585.69,
      eur: 481.91,
      gbp: 435.63,
      rub: 42964,
      inr: 43071,
      cny: 3833.02,
      try: 4591.97
    },
    '4a21c8bc-3df3-5d61-b9c4-c6c2f2296914': {
      usd: 0.00451162,
      eur: 0.00371171,
      gbp: 0.00335571,
      rub: 0.330944,
      inr: 0.331785,
      cny: 0.02952404,
      try: 0.03538924
    },
    'a9cc6884-14bd-53b6-abcd-f9b56b60463d': {
      usd: 0.02086022,
      eur: 0.0171617,
      gbp: 0.01551568,
      rub: 1.53,
      inr: 1.53,
      cny: 0.136509,
      try: 0.163628
    },
    '34eeb9ed-4225-515b-9cb1-d93fd16d78c2': {
      usd: 0.00267466,
      eur: 0.002201,
      gbp: 0.00199008,
      rub: 0.196185,
      inr: 0.197283,
      cny: 0.01749037,
      try: 0.02095891
    },
    '112d920e-96e8-57cd-b141-6dd63fa90d31': {
      usd: 0.181848,
      eur: 0.149606,
      gbp: 0.135257,
      rub: 13.34,
      inr: 13.37,
      cny: 1.19,
      try: 1.43
    },
    '0765f5fa-f31e-5aa9-9122-c20b90d686f3': {
      usd: 1.48,
      eur: 1.22,
      gbp: 1.1,
      rub: 108.56,
      inr: 108.76,
      cny: 9.68,
      try: 11.61
    },
    '3ebda70e-d4a9-5a20-81a1-32f1109d3121': {
      usd: 3.14,
      eur: 2.59,
      gbp: 2.34,
      rub: 230.54,
      inr: 231.12,
      cny: 20.57,
      try: 24.65
    },
    '59a6f871-34bb-5914-86cc-b5f1307bb3b9': {
      usd: 0.111634,
      eur: 0.091852,
      gbp: 0.083031,
      rub: 8.19,
      inr: 8.21,
      cny: 0.730501,
      try: 0.875559
    },
    'e34bb9ff-47be-503b-956b-30d4b3f3507b': {
      usd: 0.220291,
      eur: 0.181254,
      gbp: 0.163848,
      rub: 16.16,
      inr: 16.2,
      cny: 1.44,
      try: 1.73
    },
    '13c0661d-68f1-5b8f-8ff8-410bb67c5f06': {
      usd: 0.00061639,
      eur: 0.00050711,
      gbp: 0.00045847,
      rub: 0.04521464,
      inr: 0.04532941,
      cny: 0.00403366,
      try: 0.00483498
    },
    'f0935aad-cb4c-5f72-bc59-79879d718c87': {
      usd: 0.00027826,
      eur: 0.00022895,
      gbp: 0.00020696,
      rub: 0.02041122,
      inr: 0.02046262,
      cny: 0.00182083,
      try: 0.0021824
    },
    '2f16477d-6bd6-5fac-8b9e-3f0772b6489d': {
      usd: 0.76692,
      eur: 0.630945,
      gbp: 0.57043,
      rub: 56.26,
      inr: 56.4,
      cny: 5.02,
      try: 6.02
    },
    '12470ffd-9ed1-5899-80b8-b1d30b1d1194': {
      usd: 0.110922,
      eur: 0.091266,
      gbp: 0.082501,
      rub: 8.14,
      inr: 8.16,
      cny: 0.725837,
      try: 0.869969
    },
    'c469f604-d610-5252-8f8b-580ca1837e58': {
      usd: 3.08,
      eur: 2.53,
      gbp: 2.29,
      rub: 225.65,
      inr: 226.21,
      cny: 20.13,
      try: 24.13
    },
    '6c1e671f-9af5-546d-9c1a-52067bdf0e53': {
      usd: 6,
      eur: 4.94,
      gbp: 4.47,
      rub: 440.45,
      inr: 441.57,
      cny: 39.29,
      try: 47.1
    },
    'a7dad681-9933-56fd-a593-7b4746b7304b': {
      usd: 12.11,
      eur: 9.97,
      gbp: 9.01,
      rub: 888.53,
      inr: 890.77,
      cny: 79.26,
      try: 95
    },
    'd3230312-cacb-52e6-a849-8bbf6e8142dd': {
      usd: 524.07,
      eur: 431.2,
      gbp: 389.79,
      rub: 38442,
      inr: 38539,
      cny: 3429.35,
      try: 4110.32
    },
    '52f6407e-e3de-50f6-a26a-23702e0efc16': {
      usd: 2.76,
      eur: 2.27,
      gbp: 2.05,
      rub: 202.58,
      inr: 203.09,
      cny: 18.07,
      try: 21.66
    },
    'a24f0eba-c56c-5095-8b45-d4bd5b7063d7': {
      usd: 5.2,
      eur: 4.28,
      gbp: 3.87,
      rub: 381.36,
      inr: 382.32,
      cny: 34.02,
      try: 40.78
    },
    'c9a85d0b-5f75-5fd7-9cd2-b94ba5caceef': {
      usd: 151.04,
      eur: 124.27,
      gbp: 112.34,
      rub: 11079.19,
      inr: 11107.09,
      cny: 988.35,
      try: 1184.6
    },
    '42362ed0-333d-5123-ae7d-29b79178769d': {
      usd: 14.62,
      eur: 12.03,
      gbp: 10.88,
      rub: 1072.77,
      inr: 1075.47,
      cny: 95.7,
      try: 114.7
    },
    '281fa3af-8e6d-5f33-900c-33a480035475': {
      usd: 84.51,
      eur: 69.53,
      gbp: 62.86,
      rub: 6199.05,
      inr: 6214.66,
      cny: 553,
      try: 662.81
    },
    '1c77b322-a88c-57cc-b956-78c2bc17c360': {
      usd: 0.844412,
      eur: 0.694778,
      gbp: 0.628056,
      rub: 61.94,
      inr: 62.1,
      cny: 5.53,
      try: 6.62
    },
    '34d158c5-eed0-51ad-8252-5336a391958a': {
      usd: 0.01476614,
      eur: 0.01214951,
      gbp: 0.01098275,
      rub: 1.08,
      inr: 1.09,
      cny: 0.096625,
      try: 0.115812
    },
    '53306efd-fb16-5e9a-b6d0-fc0e9713da40': {
      usd: 3.08,
      eur: 2.54,
      gbp: 2.29,
      rub: 226.29,
      inr: 226.9,
      cny: 20.19,
      try: 24.2
    },
    '685f1c7f-2d31-56c2-ae80-9cd433aeb0e1': {
      usd: 1,
      eur: 0.822867,
      gbp: 0.743844,
      rub: 73.36,
      inr: 73.54,
      cny: 6.54,
      try: 7.84
    },
    'e6b79bdf-4c78-5719-aa76-e9944ac8a849': {
      usd: 0.00002652,
      eur: 0.00002182,
      gbp: 0.00001973,
      rub: 0.00194543,
      inr: 0.00195033,
      cny: 0.00017355,
      try: 0.00020801
    },
    '3dcbc269-fa47-5707-b180-4cb0ba6e5cdf': {
      usd: 15.87,
      eur: 13.06,
      gbp: 11.8,
      rub: 1164.2,
      inr: 1167.13,
      cny: 103.86,
      try: 124.48
    },
    'd3e4675a-4ca4-5e05-a4d7-445edcd76965': {
      usd: 0.00112129,
      eur: 0.00092259,
      gbp: 0.00083399,
      rub: 0.082251,
      inr: 0.082458,
      cny: 0.00733736,
      try: 0.00879436
    },
    'c90311b2-90b2-5bf4-8d93-e06bd7cfb666': {
      usd: 1,
      eur: 0.822902,
      gbp: 0.743876,
      rub: 73.36,
      inr: 73.55,
      cny: 6.54,
      try: 7.84
    },
    '543a4909-8501-575f-b3a5-f3f7117dcc8b': {
      usd: 0.00003117,
      eur: 0.00002565,
      gbp: 0.00002342,
      rub: 0.00227833,
      inr: 0.00229343,
      cny: 0.00020385,
      try: 0.00024631
    },
    '8c5ef44a-ffef-5478-929d-488b0135192f': {
      usd: 0.052982,
      eur: 0.04358829,
      gbp: 0.03940208,
      rub: 3.89,
      inr: 3.9,
      cny: 0.346465,
      try: 0.415077
    },
    'daaceb9e-7d95-54fb-a924-d4d013adfb4c': {
      usd: 0,
      eur: 0,
      gbp: 0,
      rub: 0,
      inr: 0,
      cny: 0,
      try: 0
    },
    'b4ebfad5-090f-534e-aa26-e77035adc0fc': {
      usd: 0.04165293,
      eur: 0.03427182,
      gbp: 0.03098057,
      rub: 3.06,
      inr: 3.06,
      cny: 0.272564,
      try: 0.326688
    },
    'b79cdc9b-9a97-5413-9a0b-bee09c086c78': {
      usd: 0.00230872,
      eur: 0.00207448,
      gbp: 0.00179052,
      rub: 0.147582,
      inr: 0.163863,
      cny: 0.01632915,
      try: 0.01329806
    },
    'c697f7c1-5f8a-5de8-ae44-22687bba713a': {
      usd: 0.00721442,
      eur: 0.00659903,
      gbp: 0.0058711,
      rub: 0.466919,
      inr: 0.508346,
      cny: 0.05138,
      try: 0.04088155
    },
    '7c39f1de-8bc8-5d03-bee5-6451741664bd': {
      usd: 0.060986,
      eur: 0.050189,
      gbp: 0.04537778,
      rub: 4.48,
      inr: 4.49,
      cny: 0.399123,
      try: 0.478381
    },
    '7dc10f7d-a63a-516f-a6a1-da2320f1a845': {
      usd: 0.00002331,
      eur: 0.00001919,
      gbp: 0.00001735,
      rub: 0.00170706,
      inr: 0.00171935,
      cny: 0.00015243,
      try: 0.00018263
    },
    'a3131ec3-7689-50b3-b135-0d36a676c90b': {
      usd: 0.00086528,
      eur: 0.00071194,
      gbp: 0.00064357,
      rub: 0.063471,
      inr: 0.063631,
      cny: 0.0056621,
      try: 0.00678644
    },
    'd48a25ca-8d2b-596f-a852-79407565b6e4': {
      usd: 0.076655,
      eur: 0.063072,
      gbp: 0.057015,
      rub: 5.62,
      inr: 5.64,
      cny: 0.501609,
      try: 0.601215
    },
    'f774001a-d201-5445-b63a-6221f63c237b': {
      usd: 0.00518912,
      eur: 0.00433969,
      gbp: 0.00390096,
      rub: 0.394464,
      inr: 0.383684,
      cny: 0.03412887,
      try: 0.04052187
    },
    '778541d2-65e6-5c57-b083-aa3129eb91c8': {
      usd: 1.75,
      eur: 1.44,
      gbp: 1.3,
      rub: 128.63,
      inr: 128.95,
      cny: 11.47,
      try: 13.75
    },
    '4ca1289d-7126-5a11-8be3-2fc7f6c45820': {
      usd: 0.00209528,
      eur: 0.00172398,
      gbp: 0.0015585,
      rub: 0.153695,
      inr: 0.154087,
      cny: 0.01371316,
      try: 0.01643593
    },
    'cfd7b234-57bd-5306-89e8-3d477c4cbb83': {
      usd: 0.00622422,
      eur: 0.00512125,
      gbp: 0.00462944,
      rub: 0.45657,
      inr: 0.457719,
      cny: 0.0407294,
      try: 0.04881715
    },
    'e02a1b4e-ab8b-5894-a49e-a36b74bd99ab': {
      usd: 12.17,
      eur: 10.01,
      gbp: 9.05,
      rub: 892.37,
      inr: 894.62,
      cny: 79.61,
      try: 95.41
    },
    '5e895083-fac7-5033-ae8a-a0f317f230ff': {
      usd: 0.093703,
      eur: 0.077098,
      gbp: 0.069694,
      rub: 6.87,
      inr: 6.89,
      cny: 0.613164,
      try: 0.734921
    },
    'd339805d-b72c-5546-a10e-2a74f425d9d2': {
      usd: 0.00004157,
      eur: 0.00003799,
      gbp: 0.00003383,
      rub: 0.00268778,
      inr: 0.00293689,
      cny: 0.00029608,
      try: 0.00023572
    },
    'b3aed520-c84f-566c-9431-5263a2d40460': {
      usd: 0.03589272,
      eur: 0.02953235,
      gbp: 0.02669625,
      rub: 2.63,
      inr: 2.64,
      cny: 0.234871,
      try: 0.28151
    },
    '93686561-3c9d-5bc8-81bf-0334150be221': {
      usd: 0.00987544,
      eur: 0.00913139,
      gbp: 0.00763171,
      rub: 0.639568,
      inr: 0.709521,
      cny: 0.069435,
      try: 0.060704
    },
    '5d06038d-8c66-5921-958e-4be4421944c5': {
      usd: 0.0009832,
      eur: 0.00080897,
      gbp: 0.00073132,
      rub: 0.072121,
      inr: 0.072305,
      cny: 0.00643486,
      try: 0.00771252
    },
    '00ff8c75-22ce-5e15-b06a-770154d7e333': {
      usd: 1,
      eur: 0.823818,
      gbp: 0.744646,
      rub: 73.45,
      inr: 73.64,
      cny: 6.55,
      try: 7.85
    },
    'c0ae47d5-f020-5ea8-9886-522d3af70845': {
      usd: 12.49,
      eur: 10.28,
      gbp: 9.29,
      rub: 916.09,
      inr: 918.39,
      cny: 81.72,
      try: 97.95
    }
  },
  settings: {
    fiatCurrency: 'USD',
    darkMode: false,
    isDemoMode: true,
    dashboardAccounts: [
      'f535254d-4740-5b81-a333-b2440d785991',
      '624d4cb6-b9ba-5b46-b40b-02bf4e435b08',
      'f625fa21-20ed-5154-a785-d88fbb85f58a',
      '78d42968-6071-5a72-8dd0-9ca4c6c55e83'
    ],
    excludedAssets: [],
    language: 'en',
    node: 'web3'
  },
  networkNodes: {},
  userActions: {
    'a4536899-f118-4c18-bd03-defaaa12ead3': {
      name: 'migrate_gol',
      state: 'hidden',
      uuid: 'a4536899-f118-4c18-bd03-defaaa12ead3'
    },
    'ddd7f54f-7213-434f-a270-1e7336f7aa78': {
      name: 'telegram',
      state: 'hidden',
      uuid: 'ddd7f54f-7213-434f-a270-1e7336f7aa78'
    },
    '11f677ac-554d-4638-ac45-ac5e9c462823': {
      name: 'newsletter',
      state: 'hidden',
      uuid: '11f677ac-554d-4638-ac45-ac5e9c462823'
    },
    '159376f3-f604-4199-b656-381fffdaa7df': {
      name: 'swap',
      state: 'hidden',
      uuid: '159376f3-f604-4199-b656-381fffdaa7df'
    },
    'af5135c7-60c5-4023-83f1-866263eae81b': {
      name: 'twitter',
      state: 'hidden',
      uuid: 'af5135c7-60c5-4023-83f1-866263eae81b'
    },
    'd80b67e2-b4a2-455e-a25a-38556e354014': {
      name: 'migrate_ant',
      state: 'new',
      uuid: 'd80b67e2-b4a2-455e-a25a-38556e354014'
    },
    'ade94b9e-e186-46a6-8579-08e053013549': {
      name: 'buy_hw',
      state: 'hidden',
      uuid: 'ade94b9e-e186-46a6-8579-08e053013549'
    },
    '338c2135-56e7-4364-b43b-77fcf66dd6b6': {
      name: 'update_label',
      state: 'completed',
      uuid: '338c2135-56e7-4364-b43b-77fcf66dd6b6'
    },
    'd6d71b9e-cb6a-4ff2-8465-34b79bff970e': {
      name: 'add_account',
      state: 'new',
      uuid: 'd6d71b9e-cb6a-4ff2-8465-34b79bff970e'
    },
    '39e66d3f-f932-4f98-bf8c-5e2039a92ce2': {
      name: 'myc_membership',
      state: 'hidden',
      uuid: '39e66d3f-f932-4f98-bf8c-5e2039a92ce2'
    },
    '6df1ee49-d545-4631-8dad-ed2156741d00': {
      name: 'feedback',
      state: 'hidden',
      uuid: '6df1ee49-d545-4631-8dad-ed2156741d00'
    },
    'e2c59196-42bd-4dc5-84be-af0c11ccbeeb': {
      name: 'backup',
      state: 'hidden',
      uuid: 'e2c59196-42bd-4dc5-84be-af0c11ccbeeb'
    },
    '206bda29-adbf-4acb-9d10-22d42badb0af': {
      name: 'myc_winter_start',
      state: 'new',
      uuid: '206bda29-adbf-4acb-9d10-22d42badb0af'
    },
    'ba102a93-ba7d-46d3-9532-428501a6420b': {
      name: 'myc_winter_mid',
      state: 'hidden',
      uuid: 'ba102a93-ba7d-46d3-9532-428501a6420b'
    },
    'fce0fd16-f2c3-4b17-b867-072e0f5b33cd': {
      name: 'migrate_lend',
      state: 'new',
      uuid: 'fce0fd16-f2c3-4b17-b867-072e0f5b33cd'
    }
  }
};
